import { env as appsInTossEnv, getOperationalEnvironment } from '@apps-in-toss/web-framework';

const PRIVATE_DEPLOYMENT_HOST_SUFFIXES = [
  '.private-apps.tossmini.com', // SDK 2.x 및 3.1.1+ 콘솔 QR 테스트
  '.private-web.tossmini.com',  // SDK 3.0.0 ~ 3.1.0 콘솔 QR 테스트
] as const;

/** 앱인토스 콘솔 QR 테스트 전용 origin인지 판별한다. */
export function isPrivateDeploymentHost(
  hostname = typeof window === 'undefined' ? '' : window.location.hostname
): boolean {
  const normalized = hostname.trim().toLowerCase();
  return PRIVATE_DEPLOYMENT_HOST_SUFFIXES.some((suffix) => normalized.endsWith(suffix));
}

/** 콘솔 QR 테스트 origin에서만 SDK의 현재 배포 ID를 반환한다. */
export function getPrivateDeploymentId(): string | null {
  if (!isPrivateDeploymentHost()) return null;
  try {
    const deploymentId = appsInTossEnv.getDeploymentId();
    return typeof deploymentId === 'string' && deploymentId !== '' && deploymentId !== 'local'
      ? deploymentId
      : null;
  } catch {
    return null;
  }
}

/**
 * 미니앱이 Toss 생태계(프로덕션 토스앱 or 샌드박스 앱) 안에서 실행 중인지 판정.
 *
 * 1순위: SDK의 `getOperationalEnvironment()` — `'toss' | 'sandbox'` 반환. 샌드박스에서도
 *         true가 되어야 하기 때문에 UA 단독 판정은 불가.
 * 2순위: 일반 브라우저/어드민/PC 프리뷰에서는 SDK 브릿지가 없어 throw → UA로 최후 판정.
 */
export function isTossApp(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  try {
    const env = getOperationalEnvironment();
    return env === 'toss' || env === 'sandbox';
  } catch {
    return /TossApp/i.test(navigator.userAgent);
  }
}
